import actions from "./actions";

const setActiveFilter = actions.setActiveFilter;
const addNewFilter = actions.addNewFilter;
const saveFilterEdit = actions.saveFilterEdit;
const nukeFilters = actions.nukeFilters;
const removeFilter = actions.removeFilter;

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setActiveFilter,
  addNewFilter,
  saveFilterEdit,
  removeFilter,
  nukeFilters
};
